import questions from "./questions";
import styles from "./Schema.module.css";

const schema = {
  classes: {
    form: styles.loginForm,
    label: styles.questionLabel,
    questionPanelText: "lead",
    controlButton: styles.pullRight,
    backButton: styles.backButton,
    buttonBar: styles.buttonBar,
    input : "",
    radio : styles.radioInput,
    radioLabel: styles.radioLabel,
    checkbox : styles.checkboxInput,
    checkboxLabel: styles.checkboxLabel,
    select: styles.selectBox,
    errorMessage: styles.errorMsg
  },
  formPanels: [
    {
      index: 1,
      panelId: "start-panel"
    },
    {
      index: 2,
      panelId: "request-type-panel"
    },
    {
      index: 3,
      panelId: "request-type-minor-panel"
    },
    {
      index: 4,
      panelId: "pii-panel"
    },
    {
      index: 5,
      panelId: "pii-minor-panel"
    },
    {
      index: 6,
      panelId: "contact-panel"
    },
    {
      index: 7,
      panelId: "minor-contact-panel"
    },
    {
      index: 8,
      panelId: "requestor-contact-panel"
    },
    {
      index: 9,
      panelId: "report-type-panel"
    }
  ],
  questionPanels: [
    {
      panelId: "start-panel",
      panelHeader : "Let's Start Your Request",
      panelText: "You may make a request for yourself as the consumer, or on behalf of a another person as their parent or guardian. We do not knowingly collect personal information from individuals under the age of 13 without the consent of their parents or guardian.",
      action: {
        default: {
          action: "GOTO",
          target: "report-type-panel"
        },
        conditions: [
          {
            questionId: "PersonSubmitting",
            value: "minor",
            action: "GOTO",
            target: "report-type-panel"
          }
        ]
      },
      button: {
        text: "Next",
        disabled: false
      },
      questionSets: [
        {
          questionSetId: "person-request-set"
        }
      ]
    },
    {
      panelId: "request-type-panel",
      panelHeader : "What Type of Request Are You Making?",
      panelText : "You can request, subject to exceptions, what information we currently have for you, request to opt- out of future data sale, or request that we delete information we find for you.",
      panelFootnote : "*Cross-context behavioral advertising, is a phrase more specifically defined under California law, but is generally intended to describe the practice of presenting targeted advertisements to consumers by monitoring their online behavior over time and across non-affiliated websites.",
      action: {
        default: {
          action: "SUBMIT",
          target: "/api/formsave",
          panel: "result"
        }
      },
      button: {
        text: "SUBMIT"
      },
      questionSets: [
        {
          questionSetId: "request-type-set"
        }
      ]
    },
    {
      panelId: "report-type-panel",
      panelHeader : "How would you like us to interact with you?",
      action: {
        default: {
          action: "GOTO",
          target: "pii-panel"
        },
        conditions: [
          {
            questionId: "PersonSubmitting",
            value: "minor",
            action: "GOTO",
            target: "pii-minor-panel"
          }
        ]
      },
      button: {
        text: "Next"
      },
      questionSets: [
        {
          questionSetId: "report-type-set"
        }
      ]
    },
    {
      panelId: "request-type-minor-panel",
      panelHeader : "What Type of Request Are You Making?",
      panelText : "You can request, subject to exceptions, what information we currently have for your child or dependent, request to opt-out of future data sale, or request that we delete all information we find for your child/dependent.",
      panelFootnote : "*Cross-context behavioral advertising, is a phrase more specifically defined under California law, but is generally intended to describe the practice of presenting targeted advertisements to consumers by monitoring their online behavior over time and across non-affiliated websites.",
      action: {
        default: {
          action: "SUBMIT",
          target: "/api/formsave",
          panel: "result"
        }
      },
      button: {
        text: "SUBMIT"
      },
      questionSets: [
        {
          questionSetId: "request-type-set"
        }
      ]
    },
    {
      panelId: "pii-panel",
      panelHeader : "Tell Us About Yourself",
      panelText : "We need to collect this information in order to verify your identity and find relevant information about you in our data sources.",
      action: {
        default: {
          action: "GOTO",
          target: "contact-panel"
        }
      },
      button: {
        text: "Next",
        disabled: false
      },
      questionSets: [
        {
          questionSetId: "pii-set"
        }
      ]
    },
    {
      panelId: "contact-panel",
      panelHeader : "Provide us your contact information",
      panelText : "We need to collect this information to also validate you and to contact you if we have any questions.  Note:  The response to your request will be sent to the email address or mailing address on file based on your earlier selection.",
      action: {
        default: {
          action: "GOTO",
          target: "request-type-panel"
        }
      },
      button: {
        text: "Next",
        disabled: false
      },
      questionSets: [
        {
          questionSetId: "contact-set"
        }
      ]
    },
    {
      panelId: "minor-contact-panel",
      panelHeader : "Let Us Know How to Contact You",
      panelText : "We need to collect this information in order to verify your address in our records, know where to send your report, and contact you if we have any questions",
      action: {
        default: {
          action: "GOTO",
          target: "request-type-minor-panel"
        }
      },
      button: {
        text: "Next",
        disabled: false
      },
      questionSets: [
        {
          questionSetId: "contact-set"
        }
      ]
    },
    {
      panelId: "pii-minor-panel",
      panelHeader : "Make a Request on Behalf of a Child/Dependent",
      panelText : "You may make a request on behalf of a minor under the age of 13 years or dependent in your care. Please note, you must visit a branch after you submit your request to confirm you are authorized to file on behalf of this consumer.  The request will not be processed until this step is complete.",
      action: {
        default: {
          action: "GOTO",
          target: "requestor-contact-panel"
        }
      },
      button: {
        text: "Next",
        disabled: false
      },
      questionSets: [
        {
          questionSetId: "pii-minor-set"
        }
      ]
    },
    {
      panelId: "requestor-contact-panel",
      panelHeader : "Now, Tell Us About Yourself",
      action: {
        default: {
          action: "GOTO",
          target: "request-type-minor-panel"
        }
      },
      button: {
        text: "Next",
        disabled: false
      },
      questionSets: [
        {
          questionSetId: "requestor-pii-set"
        }
      ]
    }
  ],
  questionSets: questions
};

export default schema;
